import React, { useEffect } from 'react';
import './Wrapper.scss';
import useAccountData from '../../../hooks/account/UseAccountData';
import Loader from '../loader/Loader';
import { useNavigate, useParams } from 'react-router-dom';
import { PROJECTS } from '../../../routes/path';
import { useAccount } from '../../../contexts/account/AccountContexts';
import useBilling from '../../../hooks/account/UseBilling';
import { useAccountSubscriptionSocket } from '../../../hooks/socket/UseAccountSubscriptionSocket';

interface WrapperProps {
  children: React.ReactNode;
  checkSuperAdmin?: boolean;
  canShowPricing?: boolean;
}

const Wrapper: React.FC<WrapperProps> = ({
  children,
  checkSuperAdmin = false,
  canShowPricing = false,
}) => {
  const { projectId } = useParams();
  const loading = useAccountData(projectId);
  const navigate = useNavigate();
  const { accountResponse } = useAccount();
  const canShowBilling = useBilling();
  useAccountSubscriptionSocket();

  useEffect(() => {
    if (!loading && canShowPricing && !canShowBilling) {
      navigate(PROJECTS);
    }

    if (!loading && checkSuperAdmin && (!accountResponse || !accountResponse.isSuperAdmin)) {
      navigate(PROJECTS);
    }
  }, [checkSuperAdmin, canShowPricing, navigate, loading]);

  if (loading) {
    return <Loader />;
  }

  return <div>{children}</div>;
};

export default Wrapper;
